import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const OpenGraph = ({
                     url,
                     title,
                     description,
                     image,
                     isBlogPost = false,
                   }) => (
  <Helmet>
    <meta property="og:url" content={url}/>
    {isBlogPost ? <meta property="og:type" content="article"/> : <meta property="og:type" content="website" />}
    <meta property="og:title" content={title}/>
    <meta property="og:description" content={description}/>
    <meta property="og:image" content={image}/>
    <meta property="og:site_name" content="Apostrophe"/>
  </Helmet>
);

OpenGraph.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isBlogPOst: PropTypes.bool,
};

export default OpenGraph;


// WEBPACK FOOTER //
// ./src/components/Head/OpenGraph.js